import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SeparatorComponent } from './separator.component';
import { LightIconButtonComponent } from '../buttons/light-icon-button-component';
import {
  UserSpecificConfigLoyalty,
  UserSpecificConfigLoyaltyDiscountCode,
  UserSpecificConfigLoyaltyRewardTrigger
} from '../../models/Order';
import { TranslateService } from '../../services/translate.service';

@Component({
  selector: 'app-loyalty-info',
  standalone: true,
  imports: [CommonModule, SeparatorComponent, LightIconButtonComponent],
  template: `
    <div>
      <app-separator></app-separator>
      <div class="flex flex-row mt-4 items-center">
        <i class="fas fa-crown mr-2"></i>
        <div class="flex-1 text-lg font-bold">{{loyaltyInfo?.name}}</div>
      </div>
      <div *ngIf="loyaltyInfo?.codes != null && loyaltyInfo!.codes!.length > 0">
        <div *ngFor="let code of loyaltyInfo?.codes" class="flex flex-col gap-4">
          <div class="flex flex-row items-center">
            <div class="flex-1 text-lg text-theme-text2 font-bold">{{code.message}}</div>
            <app-light-icon-button
              *ngIf="!code.active && (activeCode == null || activeCode !== code.code)"
              icon="fa-toggle-off"
              (onClick)="onActivateDiscount(code)"
              [text]="getString('Aktivera')">
            </app-light-icon-button>
            <div *ngIf="code.active || activeCode === code.code" class="text-lg tabular-nums font-medium">-{{discountFormatted}}</div>
          </div>
        </div>
      </div>
      <div *ngIf="loyaltyInfo?.codes == null || loyaltyInfo?.codes?.length === 0">
        <div class="flex flex-row mt-1 items-center">
          <div class="text-lg">{{getString("Samlade poäng")}}</div>
          <div class="text-lg tabular-nums ml-2 py-1 px-2 border">{{ loyaltyInfo?.points ? (loyaltyInfo?.points | number) + ' p' : '0 p' }}</div>
        </div>
        <div class="flex flex-row mt-1" *ngIf="loyaltyInfo?.reward_trigger">
          <div class="flex-1 text-lg text-theme-text3">{{loyaltyInfo?.reward_trigger?.message}}</div>
          <app-light-icon-button
            *ngIf="loyaltyInfo?.reward_trigger?.triggered"
            icon="fa-toggle-off"
            (onClick)="onActivateReward(loyaltyInfo?.reward_trigger)"
            [text]="getString('Aktivera')">
          </app-light-icon-button>
        </div>
      </div>
    </div>
  `
})
export class LoyaltyInfoComponent {
  @Input() loyaltyInfo: UserSpecificConfigLoyalty | undefined;
  @Input() discountFormatted: string | undefined;
  @Input() activeCode: string | undefined;

  @Output() activateDiscountCode = new EventEmitter<UserSpecificConfigLoyaltyDiscountCode>();
  @Output() activateReward = new EventEmitter<UserSpecificConfigLoyaltyRewardTrigger>();

  constructor(private translate: TranslateService) {}

  getString(s: string): string {
    return this.translate.getString(s);
  }

  onActivateDiscount(code?: UserSpecificConfigLoyaltyDiscountCode): void {
    this.activateDiscountCode.emit(code);
  }

  onActivateReward(trigger?: UserSpecificConfigLoyaltyRewardTrigger): void {
    this.activateReward.emit(trigger);
  }
}
